// import SendBird from 'sendbird'
import {parseUrl} from '../scenes/SendbirdMessenger/util'
import {getMessengerClient} from '../utils/messenger'

export const sbCreateGroupChannelListQuery = () => {
  const sb = getMessengerClient()
  return sb.GroupChannel.createMyGroupChannelListQuery()
}

export const sbGetGroupChannelList = groupChannelListQuery => {
  return new Promise((resolve, reject) => {
    groupChannelListQuery.next((channels, error) => {
      if (error) {
        reject(error)
      } else {
        resolve(channels)
      }
    })
  })
}

export const sbGetGroupChannel = channelUrl => {
  let url = 'sendbird_group_channel_' + parseUrl(channelUrl)
  return new Promise((resolve, reject) => {
    const sb = getMessengerClient()
    sb.GroupChannel.getChannel(url, (channel, error) => {
      if (error) {
        reject(error)
      } else {
        resolve(channel)
      }
    })
  })
}

export const sbLeaveGroupChannel = channelUrl => {
  return new Promise((resolve, reject) => {
    // const sb = getMessengerClient()
    sbGetGroupChannel(channelUrl)
      .then(channel => {
        channel.leave((response, error) => {
          if (error) {
            reject(error)
          } else {
            resolve(response)
          }
        })
      })
      .catch(error => reject(error))
  })
}

export const sbHideGroupChannel = channelUrl => {
  return new Promise((resolve, reject) => {
    // const sb = getMessengerClient()
    sbGetGroupChannel(channelUrl)
      .then(channel => {
        channel.hide(true, true, (response, error) => {
          if (error) {
            reject(error)
          } else {
            resolve(response)
          }
        })
      })
      .catch(error => reject(error))
  })
}

export const sbCreateUserListQuery = () => {
  const sb = getMessengerClient()
  return sb.createApplicationUserListQuery()
}

export const sbGetUserList = userListQuery => {
  return new Promise((resolve, reject) => {
    userListQuery.next((users, error) => {
      if (error) {
        reject(error)
      } else {
        resolve(users)
      }
    })
  })
}

export const sbCreateGroupChannel = (inviteUserIdList, isDistinct) => {
  return new Promise((resolve, reject) => {
    const sb = getMessengerClient()
    sb.GroupChannel.createChannelWithUserIds(inviteUserIdList, isDistinct, (channel, error) => {
      if (error) {
        reject(error)
      } else {
        resolve(channel)
      }
    })
  })
}

export const sbInviteGroupChannel = (inviteUserIdList, channelUrl) => {
  return new Promise((resolve, reject) => {
    sbGetGroupChannel(channelUrl)
      .then(channel => {
        channel.inviteWithUserIds(inviteUserIdList, (channel, error) => {
          if (error) {
            reject(error)
          } else {
            resolve(channel)
          }
        })
      })
      .catch(error => {
        reject(error)
      })
  })
}
